import moment from 'moment';

/**
 * agDateColumnFilterに渡すcomparator
 * @param selectedDate Dateコンポーネントで選択された日付
 * @param cellString セルの値（文字列）
 * @returns -1 | 0 | 1
 */
const dateFilterComparator = (selectedDate: Date, cellString: string): number => {
  // console.log('valueDate: ', valueDate, 'valueString: ', valueString);
  const isCellStringValidDate: boolean = moment(cellString).isValid();
  if (isCellStringValidDate) {
    const cellDate: Date = moment(cellString).toDate();
    if (cellDate < selectedDate) {
      return -1;
    } else if (cellDate > selectedDate) {
      return 1;
    } else {
      return 0;
    }
  } else {
    // console.log('cellString is not valid date: ', cellString);
    return -1;
  }
};

export default dateFilterComparator;
